import React, { Component } from "react";
import cookie from "react-cookies";
import { editorURL } from "../../Helpers/Config";
import { userID } from "../../Helpers/SettingHelper";

class EmailBuilder extends Component {
  constructor(props) {
    super(props);
    var companyID = cookie.load("companyID");
    var editID = this.props?.location?.TemplateID || '';
    this.state = {
      companyID: companyID,
      loginID: userID(),
      editID: editID,
    };
  }
  render() {
    var body = document.body,
      html = document.documentElement;
    var height_ = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);

    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="iframe-container">
          {/* dev */}
          <iframe
            src={`${editorURL}design.php?id=6037a0a8583a7&type=default&token=${cookie.load("clientAccessToken")}&templateID=${this.state.editID}&company_id=${this.state.companyID}&loginID=${
              this.state.loginID
            }&apimode=live`}
            frameBorder={0}
            style={{ height: height_ + "px", width: "100%" }}
            title="EmailBuilder"
          ></iframe>
        </div>
      </div>
    );
  }
}

export default EmailBuilder;
